import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

import RoleInfoDescription from "./role-info-description";
import RoleInfoSkills from "./role-info-skills";
import Role from "../../../../utils/interfaces/IRole";
import "../../../../App.scss";
import "./role-info.scss";

import { ReactComponent as LeftHideDrawer } from "../../../../assets/left-hide-role-info.svg";
import { ReactComponent as CloseRoleInfo } from "../../../../assets/close-role-info.svg";
import { Card, IconButton } from "@mui/material";
import { Add, ErrorOutline, KeyboardArrowLeft, KeyboardArrowRight, Remove } from "@mui/icons-material";
import { Drawerinfo } from "./roleInfo.styles";
import { isMobile } from "../../../../utils/screenValidations/screen";
import { useDispatch } from "react-redux";

type RoleInfoProps = {
    setShowRoleInfo: (value: boolean) => void;
    selectedRole: Role | null;
    showRoleInfo?: boolean;
    zoomIn: () => void;
    zoomOut: () => void;
};
const RoleInfo = ({ setShowRoleInfo, selectedRole, showRoleInfo = false, zoomIn, zoomOut }: RoleInfoProps) => {
    const [showInfoDescription, setShowInfoDescription] = useState(true);
    const [showInfoSkill, setShowInfoSkill] = useState(false);
    const [selectedItemMenu, setSelectedItemMenu] = useState({ descriptionColor: "#F7F7FF", skillColor: "#9192AD" });
    const [halfHidden, setHalfHidden] = useState(false);
    const [showInfosToMobile, setShowInfosToMobile] = useState(false);
    const showDescriptionInfo = () => {
        setSelectedItemMenu({ descriptionColor: "#F7F7FF", skillColor: "#9192AD" });
        setShowInfoDescription(true);
        setShowInfoSkill(false);
    };

    const showSkillsInfo = () => {
        setSelectedItemMenu({ descriptionColor: "#9192AD", skillColor: "#F7F7FF" });
        setShowInfoDescription(false);
        setShowInfoSkill(true);
    };

    const toggleHalfHidden = () => {
        setHalfHidden(!halfHidden);
    };

    useEffect(() => {
        setHalfHidden(false);
    }, [showRoleInfo, selectedRole]);

    return (
        <>
            <Drawerinfo
                half_hidden={String(halfHidden)}
                is_mobile={String(isMobile() && !!showInfosToMobile)}
                show_role_info={String(!!showRoleInfo)}
                className="drawer-info"
                variant="permanent"
                anchor="right"
            >
                <Box display={!halfHidden ? "block" : "none"} paddingBottom={20}>
                    <Box className="roleInfoTitle">
                        {isMobile() && (
                            <IconButton
                                onClick={() => {
                                    setShowRoleInfo(false);
                                    setHalfHidden(false);
                                    setShowInfosToMobile(false);
                                }}
                            >
                                <KeyboardArrowLeft fontSize="large" style={{ color: "white", fontSize: 34 }} />
                            </IconButton>
                        )}

                        <Typography fontFamily="IliaMontSerratBold" color="#F7F7FF" fontWeight="700" fontSize="24px" lineHeight="32.68px">
                            {selectedRole?.role}
                        </Typography>
                    </Box>
                    <Divider style={{ backgroundColor: "#9192AD66" }} />
                    <Box
                        sx={{ background: "#2F2380", padding: "16px 40px 16px 40px", width: "100%", flexShrink: "1", border: "0px, 0px, 0.5px, 0px" }}
                        justifyContent="space-between"
                    >
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography
                                    fontFamily="IliaMontSerratBold"
                                    color={selectedItemMenu["descriptionColor"]}
                                    fontWeight="700"
                                    fontSize="16px"
                                    lineHeight="19.5px"
                                    padding="8px"
                                    onClick={showDescriptionInfo}
                                    style={{ cursor: "pointer" }}
                                >
                                    Descrição
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography
                                    fontFamily="IliaMontSerratBold"
                                    color={selectedItemMenu["skillColor"]}
                                    fontWeight="700"
                                    fontSize="16px"
                                    lineHeight="19.5px"
                                    padding="8px"
                                    onClick={showSkillsInfo}
                                    style={{ cursor: "pointer" }}
                                >
                                    Skills
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider />
                    <Box>
                        {showInfoDescription && <RoleInfoDescription selectedRole={selectedRole} />}
                        {showInfoSkill && <RoleInfoSkills selectedRole={selectedRole} />}
                    </Box>
                </Box>
            </Drawerinfo>

            <CloseRoleInfo
                id="close-informations"
                onClick={() => {
                    setShowRoleInfo(false);
                    setHalfHidden(false);
                }}
                style={{
                    display: showRoleInfo ? "block" : "none",
                    right: halfHidden ? "35px" : "351px",
                }}
            />

            <LeftHideDrawer
                id="hide-informations"
                onClick={toggleHalfHidden}
                style={{
                    display: showRoleInfo ? "block" : "none",
                    transform: halfHidden ? "rotate(180deg)" : "rotate(0)",
                    right: halfHidden ? "40px" : "357px",
                }}
            />

            <div id="open-detais-mobile">
                <Card
                    onClick={() => {
                        setShowInfosToMobile(true);
                    }}
                    style={{
                        display: showRoleInfo && !showInfosToMobile ? "flex" : "none",
                        height: 80,
                        backgroundColor: "#F7F7FF",
                        boxShadow: "4px 4px 5px #00000033",
                        padding: 16,
                        borderRadius: 8,
                        width: "70vw",
                    }}
                >
                    <Box display={"flex"} width="100%" flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                        <Box display={"flex"} gap={2} alignItems={"center"}>
                            <ErrorOutline style={{ color: "#2F2380" }} />
                            <Typography fontWeight={"bold"} color={"#2F2380"} style={{ maxWidth: "80%" }}>
                                Acesse as informações sobre esse cargo
                            </Typography>
                        </Box>
                        <KeyboardArrowRight />
                    </Box>
                </Card>
            </div>

            <div
                style={{
                    right: !showRoleInfo || isMobile() ? "24px" : !halfHidden ? "400px" : "60px",
                    display: isMobile() && showInfosToMobile ? "none" : "flex",
                }}
                className="buttonsZoom"
            >
                <IconButton id="zoomIn" disableRipple onClick={() => zoomIn()}>
                    <Add style={{ color: "#2B25B8" }} />
                </IconButton>
                <IconButton disableRipple id="zoomOut" onClick={() => zoomOut()}>
                    <Remove style={{ color: "#2B25B8" }} />
                </IconButton>
            </div>
        </>
    );
};

export default RoleInfo;
